function homeOwnershipSelect(e) {
    if ($(e).is(':checked')) {
        $(e).prop('checked', true);
    } else {
        $(e).prop('checked', false);
    }
    UpdateHomeOwnershipSelection();
};

function UpdateHomeOwnershipSelection() {
    var $homeOwnershipSelections = $('#formHomeValueOwnershipContainer input#SerializedHomeOwnership:hidden');

    var homeOwnershipSelections = new Array();
    $('.HomeOwnershipSelection input:radio:checked').each(function (i, o) {
        homeOwnershipSelections.push($(o).attr('id') + ':' + $(o).val());
    });
    $homeOwnershipSelections.val(homeOwnershipSelections.join('~'));
};

$(function () {
    UpdateHomeOwnershipSelection();
});

